import { AssetsLoader } from '@dealstack/frontend/shared/components/AssetsLoader/AssetsLoader';
import { Button } from '@dealstack/frontend/shared/components/fundament/Button/Button';
import { ButtonsCenter } from '@dealstack/frontend/shared/components/fundament/Button/ButtonLayouts';
import { Modal } from '@dealstack/frontend/shared/components/fundament/Modal/Modal';
import { Text } from '@dealstack/frontend/shared/components/fundament/Text/Text';
import { SectionHeader } from '@dealstack/frontend/shared/components/SectionHeader/SectionHeader';
import { addInvestmentProgrammeNameToText } from '@dealstack/frontend/admin/pages/common-ui/format/string';
import { memo } from 'react';
import styled from 'styled-components';

interface Props {
	onClose: () => void;
	programmeName: string;
	isMIPArchived: boolean;
	onSubmit: () => void;
	isAnyInvestorActive?: boolean;
	className?: string;
}

const ArchiveMIPConfirmationModal = ({
	onClose,
	programmeName,
	isMIPArchived,
	onSubmit,
	isAnyInvestorActive,
	className,
}: Props) => {
	const text = isMIPArchived
		? {
				bodyText: `You're on your way to unarchive ${addInvestmentProgrammeNameToText(
					programmeName
				)}. From now on it will be visible to all related people.`,
				buttonText: 'Yes, please unarchive this Investment Programme',
			}
		: {
				bodyText: `This action can be undone in any time, but you need to be aware that the ${addInvestmentProgrammeNameToText(
					programmeName
				)}  won't be seen from
            this time for anyone on our platforms.`,
				buttonText: 'Yes, please archive this Investment Programme',
			};
	const warning =
		isAnyInvestorActive && !isMIPArchived
			? 'Be warned that this Investment Programme have still active Investors!'
			: null;
	return (
		<Modal onClose={onClose} className={className}>
			<AssetWrapper>
				<AssetsLoader src="/context/admin/mip-manage/attention.png" />
			</AssetWrapper>

			<SectionHeader size="h4b" title="Are you sure?" />

			<BodyText colorFaded variant="p-md">
				{text.bodyText}
			</BodyText>
			<WarningText colorError bold variant="p-md">
				{warning}
			</WarningText>
			<ButtonsCenter>
				<ArchiveButton
					onClick={onSubmit}
					icon="checkmark-circle-contained-filled"
					iconPlacement="left"
					variant="delete"
				>
					{text.buttonText}
				</ArchiveButton>
			</ButtonsCenter>
		</Modal>
	);
};

const AssetWrapper = styled.div`
	margin-bottom: 1em;
`;
const BodyText = styled(Text)`
	margin-bottom: 0.2em;
`;

const WarningText = styled(Text)``;

const ArchiveButton = styled(Button)``;

const Memoized = memo(ArchiveMIPConfirmationModal);
const Styled = styled(Memoized)`
	width: 38rem;
	text-align: center;

	${SectionHeader} {
		& > * {
			justify-content: center;
		}
	}

	${ButtonsCenter} {
		margin-top: 1.5em;
	}
`;

export { Styled as ArchiveMIPConfirmationModal };
